<template>
  <div>
    <a-dropdown style="display: inline-block; height: 100%; vertical-align: initial">
      <span style="cursor: pointer">
        <a-avatar class="avatar"
                  size="small"
                  shape="circle"
                  :src="avatar" />
        <span class="curr-user">{{user.userName}}</span>
      </span>
      <a-menu style="width: 150px"
              slot="overlay">
        <a-menu-item @click="openProfile">
          <a-icon type="user" />
          <span>个人中心</span>
        </a-menu-item>
        <a-menu-item @click="updatePassword">
          <a-icon type="key" />
          <span>密码修改</span>
        </a-menu-item>
        <a-menu-divider></a-menu-divider>
        <a-menu-item @click="updateSystemName"
                     v-hasPermission="'system:update'">
          <a-icon type="tags" />
          <span>系统名称</span>
        </a-menu-item>
        <a-menu-item @click="updateSystemIcon"
                     v-hasPermission="'system:update'">
          <a-icon type="home" />
          <span>系统图标</span>
        </a-menu-item>
        <a-menu-item @click="handleSettingClick">
          <a-icon type="setting" />
          <span>系统定制</span>
        </a-menu-item>
        <a-menu-item @click="downloadOperation">
          <a-icon type="book" />
          <span>操作手册</span>
        </a-menu-item>
        <a-menu-divider></a-menu-divider>
        <a-menu-item @click="logout">
          <a-icon type="logout" />
          <span>退出登录</span>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <update-password @success="handleUpdate"
                     @cancel="handleCancelUpdate"
                     :user="user"
                     :updatePasswordModelVisible="updatePasswordModelVisible">
    </update-password>
    <SystemName :nameVisiable="updateNameVisible"
                @success="handleSettingName"
                @close="handleCancelName"></SystemName>
    <SystemIcon :iconVisiable="updateIconVisible"
                @success="handleSettingIcon"
                @close="handleCancelIcon"></SystemIcon>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import UpdatePassword from "../personal/UpdatePassword";
import SystemName from "../system/systemname/systemName";
import SystemIcon from "../system/systemicon/systemIcon";
import { loginParamId } from "@/router/index.js";
import db from "@/utils/localstorage";
export default {
  name: "HeaderAvatar",
  components: { UpdatePassword, SystemName, SystemIcon },
  data() {
    return {
      updatePasswordModelVisible: false,
      updateNameVisible: false,
      updateIconVisible: false,
    };
  },
  computed: {
    ...mapState({
      settingBar: (state) => state.setting.settingBar.opened,
      user: (state) => state.account.user,
    }),
    avatar() {
      return `static/avatar/${this.user.avatar}`;
    },
  },
  methods: {
    handleSettingClick() {
      this.setSettingBar(!this.settingBar);
    },
    openProfile() {
      this.$router.push("/profile");
    },
    updatePassword() {
      this.updatePasswordModelVisible = true;
    },
    handleCancelUpdate() {
      this.updatePasswordModelVisible = false;
    },
    handleUpdate() {
      this.updatePasswordModelVisible = false;
      this.$message.success("更新密码成功，请重新登录系统");
      setTimeout(() => {
        this.logout();
      }, 1500);
    },
    updateSystemName() {
      this.updateNameVisible = true;
    },
    handleSettingName(name) {
      this.updateNameVisible = false;
      this.$confirm({
        title: "提示",
        content: "更新系统名称成功，是否重新登录系统",
        onOk: () => {
          this.$store.commit("setting/setSystemName", name);
          document.title = name;
          db.save("systemName", name);
          this.logout();
        },
        onCancel() {},
      });
      // this.$message.success("更新系统名称成功，请重新登录系统");
      /*  setTimeout(() => {
        this.$store.commit("setting/setSystemName", name);
        document.title = name;
        db.save("systemName", name);
        this.logout();
      }, 1500); */
    },
    handleCancelName() {
      this.updateNameVisible = false;
    },
    updateSystemIcon() {
      this.updateIconVisible = true;
    },
    handleSettingIcon() {
      this.updateIconVisible = false;
      this.$message.success("更新系统图标成功，请重新登录系统");
      setTimeout(() => {
        this.logout();
      }, 1500);
    },
    handleCancelIcon() {
      this.updateIconVisible = false;
    },
    logout() {
      let systemName = db.get("systemName");
      let systemLogo = db.get("systemLogo");
      this.$db.clear();
      db.save("systemName", systemName);
      db.save("systemLogo", systemLogo);
      this.$router.push("/login");
      location.reload();
      /* this.$get(`logout/${this.user.id}`).then(() => {
        return new Promise((resolve, reject) => {
          let oldLoginId = db.get('loginParamId')
          let systemName = db.get('systemName')
          let systemLogo = db.get('systemLogo')
          this.$db.clear()
          db.save('loginParamId', oldLoginId)
          db.save('systemName', systemName)
          db.save('systemLogo', systemLogo)
          let loginId = loginParamId ? loginParamId : db.get('loginParamId')
          if (loginId) {
            location.reload()
            // this.$router.push(`/login/${loginId}`)
          } else {
            this.$router.push('/login')
          }
        })
      }).catch(() => {
        this.$message.error('退出系统失败')
      }) */
    },
    ...mapMutations({ setSettingBar: "setting/setSettingBar" }),
    downloadOperation() {
      this.$message.loading("文件下载中···");
      this.$downloadpdf("/pdf", "系统使用说明.pdf");
    },
  },
};
</script>

<style lang="less" scoped>
.ant-avatar-sm {
  width: 30px;
  height: 30px;
}
.avatar {
  margin: 20px 4px 20px 0;
  color: #1890ff;
  background: hsla(0, 0%, 100%, 0.85);
  vertical-align: middle;
}
.curr-user {
  font-weight: 600;
  margin-left: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/common/HeaderAvatar.vue